export default __webpack_public_path__ + "static/media/library-white.870fe49d.svg";